import { createAsyncThunk } from '@reduxjs/toolkit';
import { getEvents, getEventImages } from '../../services/event';

export const getEventList = createAsyncThunk(
    'event',
    async (data, { getState, rejectWithValue }) => {
      try {
        const token = getState().auth.token;
        const response = await getEvents(data, token.token);
        
        return { data: response.data.list, total: response.data.total };
      } catch (err) {
        console.log(err.response.data.error)        
        return rejectWithValue(err.response?.data?.error || 'Failed to fetch events');
      }
    }
  );

export const getEventImagesById = createAsyncThunk(
    'eventimages',
    async (id, { getState, rejectWithValue }) => {
      try {
        const token = getState().auth.token;
        const response = await getEventImages(id, token.token);
        
        return { data: response.data.data, total: response.data.data.length };
      } catch (err) {
        console.log(err.response.data.error)        
        return rejectWithValue(err.response?.data?.error || 'Failed to fetch student life');
      }
    }
  );
  